<lx-loading-spinner [loading]="loadingInfo()?.loading" [message]="loadingInfo()?.message" shadingColor="rgba(0,0,0,0.5)" [positionRelative]="false" />
<div pFocusTrap class="online-quote-tool" lxScrollTopOnNavigate>
  <div class="online-quote-tool__header">
    <div class="online-quote-tool__header__container" [class.online-quote-tool__header__container--with-back-button]="withBackButton">
      @if (returnUrl(); as url) {
      <a [href]="url" class="online-quote-tool__header__container__logo"></a>
      } @else {
      <div class="online-quote-tool__header__container__logo"></div>
      } @if (withBackButton()) {
      <a class="online-quote-tool__header__container__back-link" [href]="returnUrl()" [lxGAClickEvent]="closeDataLayerEventName">
        <div class="online-quote-tool__header__container__back-link__container">
          <i class="pi pi-arrow-left"></i>
          @if (desktop()) {
          <span>{{ backButtonLabel() }}</span>
          }
        </div>
      </a>
      }
    </div>
  </div>
  <div #acquisitionDisclaimerContainer class="quote-tool__acquisition-disclaimer-container"></div>
  <div class="online-quote-tool__step-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>
